<template>
    <div class="no_data">
        <span class="no-data-icon">
            <img height="28px" src="../assets/images/actions/empty.png" alt="">
        </span>
        <div class="mt-3">
            <span>{{ $t('no_data') }}</span>
        </div>

    </div>
</template>
<script>
export default {

}</script>
<style scoped>
.no-data-icon {
    width: 56px;
    height: 56px;
    border-radius: 999px;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>